import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Plus, Pencil } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { toast } from "sonner";

const STATUSES = ["pending", "under_review", "verified", "active", "suspended", "expired", "archived"];
const inp = "w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900";
const EMPTY = { name: "", org_type: "", country: "", website: "", description: "", registration_info: "", status: "pending", compliance_status: "pending", contact_email: "", contact_phone: "", notes: "" };

export default function Partners() {
  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/partners").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (edit.id) await api.put(`/admin/partners/${edit.id}`, edit);
      else await api.post("/admin/partners", edit);
      toast.success("Partner saved"); setEdit(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="font-display text-3xl font-bold">Partner Organisations</h1>
        <button onClick={() => setEdit({ ...EMPTY })} data-testid="new-partner-btn" className="inline-flex items-center gap-2 rounded-full bg-gold px-5 py-2.5 text-sm font-bold text-white hover:bg-gold-light"><Plus className="h-4 w-4" /> New Partner</button>
      </div>

      <div className="mt-6 overflow-x-auto rounded-2xl border border-white/10 bg-[#1C2541]">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-white/10 text-left text-xs uppercase text-emerald-100/40">
            <th className="p-4">Name</th><th className="p-4">Type</th><th className="p-4">Country</th><th className="p-4">Status</th><th className="p-4">Compliance</th><th className="p-4"></th>
          </tr></thead>
          <tbody>
            {list.map((p) => (
              <tr key={p.id} className="border-b border-white/5">
                <td className="p-4 font-semibold">{p.name}{p.is_demo && <span className="ms-2 rounded bg-white/10 px-1.5 py-0.5 text-[10px] text-emerald-100/50">DEMO</span>}</td>
                <td className="p-4 text-emerald-100/60">{p.org_type}</td>
                <td className="p-4 text-emerald-100/60">{p.country}</td>
                <td className="p-4"><span className="rounded-full bg-emerald-800 px-2 py-0.5 text-xs">{p.status}</span></td>
                <td className="p-4 text-emerald-100/60">{p.compliance_status}</td>
                <td className="p-4"><button onClick={() => setEdit({ ...EMPTY, ...p })} className="rounded-lg bg-white/5 p-2 hover:bg-white/10"><Pencil className="h-4 w-4" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!edit} onOpenChange={(v) => !v && setEdit(null)}>
        <DialogContent className="max-h-[92vh] overflow-y-auto bg-white sm:max-w-xl">
          <DialogHeader><DialogTitle className="font-display text-2xl text-emerald-900">{edit?.id ? "Edit" : "New"} Partner</DialogTitle></DialogHeader>
          {edit && (
            <div className="grid grid-cols-2 gap-3 text-slate-900">
              <label className="col-span-2 text-sm">Name<input className={inp} value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} data-testid="partner-name-input" /></label>
              <label className="text-sm">Organisation Type<input className={inp} value={edit.org_type} onChange={(e) => setEdit({ ...edit, org_type: e.target.value })} /></label>
              <label className="text-sm">Country<input className={inp} value={edit.country} onChange={(e) => setEdit({ ...edit, country: e.target.value })} /></label>
              <label className="text-sm">Website<input className={inp} value={edit.website} onChange={(e) => setEdit({ ...edit, website: e.target.value })} /></label>
              <label className="text-sm">Contact Email<input className={inp} value={edit.contact_email} onChange={(e) => setEdit({ ...edit, contact_email: e.target.value })} /></label>
              <label className="text-sm">Status<select className={inp} value={edit.status} onChange={(e) => setEdit({ ...edit, status: e.target.value })} data-testid="partner-status-select">{STATUSES.map((s) => <option key={s}>{s}</option>)}</select></label>
              <label className="text-sm">Compliance<select className={inp} value={edit.compliance_status} onChange={(e) => setEdit({ ...edit, compliance_status: e.target.value })}><option>pending</option><option>under_review</option><option>verified</option></select></label>
              <label className="col-span-2 text-sm">Description<textarea rows={2} className={inp} value={edit.description} onChange={(e) => setEdit({ ...edit, description: e.target.value })} /></label>
              <label className="col-span-2 text-sm">Notes (internal)<textarea rows={2} className={inp} value={edit.notes} onChange={(e) => setEdit({ ...edit, notes: e.target.value })} /></label>
              <button onClick={save} data-testid="save-partner-btn" className="col-span-2 mt-2 rounded-full bg-emerald-900 py-3 text-sm font-bold text-white hover:bg-emerald-800">Save Partner</button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
